import {
    ACTION_SET_LOAN_PARAMS,
} from "../ActionTypes/LoanModuleActionTypes";

//check if applicant type is others
export const setIsLoanParams = (loanParameters: any) => {
  return {
    type: ACTION_SET_LOAN_PARAMS,
    loanParameters: loanParameters,
  };
};
